// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1v_uz","unreadBadge":"styles_unreadBadge__1fphG","modalContent":"styles_modalContent__2-NCy","modal":"styles_modal__1RCeR"};